import { Divider } from '@mui/material';
import MuiModal, {ModalProps} from '@mui/material/Modal';
import { CSSProperties, Fragment } from 'react';
import { Button } from '../Button';
import { Paper } from '../Paper';
import { Typography } from '../Typography';

export const Modal = (props: ModalProps & {
    title?: string
    onConfirm?: () => void
    confirmLabel?: string
    onCancel?: () => void
    cancelLabel?: string
    bodyCustomCss?: CSSProperties
}) => {
    return (
        <MuiModal {...props}>
            <Paper sx={{
                position: 'absolute' as 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                boxShadow: 24,     
            }}>
                {props.title ? (
                <Fragment>
                    <div style={{
                        padding: 15
                    }}>
                        <Typography variant="h6">
                            {props.title}
                        </Typography>
                    </div>
                <Divider />
                </Fragment>
                ) : null}
                <div style={{padding: 15, ...(props.bodyCustomCss || {})}}>
                    {props.children}
                </div>
                {(props.onConfirm || props.onCancel) ? (
                <Fragment>
                <Divider />
                    <div style={{
                        padding: 15,
                        justifyContent: props.onCancel && props.onConfirm ? 'space-between' : 'center',
                        display: props.cancelLabel && props.onConfirm ? 'flex' : 'block',
                    }}>
                        {props.onCancel && (<Button onClick={props.onCancel} variant='outlined'>{props.cancelLabel}</Button>)}
                        {props.onConfirm && (<Button onClick={props.onConfirm}>{props.confirmLabel}</Button>)}
                    </div>
                </Fragment>
                ) : null}
            </Paper>
        </MuiModal>
    )
}